import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import ListItemText from "@mui/material/ListItemText";
import DescriptionIcon from "@mui/icons-material/Description";
import DownloadIcon from "@mui/icons-material/CloudDownload";
import { PdfModal } from "../../../components/Modal/PdfModal";
import { ImageDetailModal } from "../../../components/Modal/ImageDetailModal";
import { IconButton, ListItem, ListItemIcon, Tooltip } from "@mui/material";
import getAttachmentAsset from "../../../api/getAsset";

const DocumentListItem = ({ document = { title: "", attachments: [] } }) => {
  const [previewSource, setPreviewSource] = useState();
  const [downloadUrl, setDownloadUrl] = useState();

  // Prefer the first attachment when available
  const attachment = document?.attachments?.[0];
  const attachmentFilename = attachment?.filename;
  const isPdf = attachment?.mimeType === "application/pdf";

  useEffect(() => {
    let mounted = true;
    if (!attachmentFilename) {
      setDownloadUrl(undefined);
      return () => {
        mounted = false;
      };
    }

    getAttachmentAsset(attachmentFilename).then((result) => {
      if (mounted) setDownloadUrl(result);
    });

    return () => {
      mounted = false;
    };
  }, [attachmentFilename]);

  const handlePreview = useCallback(() => {
    setPreviewSource(downloadUrl);
  }, [downloadUrl]);

  const closeModal = useCallback(() => setPreviewSource(undefined), []);

  return (
    <ListItem>
      <ListItemIcon>
        <Tooltip title={attachmentFilename || "Preview"} arrow>
          <span>
            {/* span wrapper so Tooltip works even when IconButton is disabled */}
            <IconButton
              onClick={handlePreview}
              disabled={!downloadUrl}
              aria-label="open document preview"
            >
              <DescriptionIcon />
            </IconButton>
          </span>
        </Tooltip>
      </ListItemIcon>

      <ListItemText primary={document.title} />

      {/* download button */}
      <Tooltip title={downloadUrl ? "Download" : "No file available"} arrow>
        <span>
          <IconButton
            href={downloadUrl}
            download
            target="_blank"
            disabled={!downloadUrl}
            aria-label="download document"
          >
            <DownloadIcon />
          </IconButton>
        </span>
      </Tooltip>

      {isPdf ? (
        <PdfModal source={previewSource} closeModal={closeModal} />
      ) : (
        <ImageDetailModal
          imageSourceForModal={previewSource}
          closeModal={closeModal}
        />
      )}
    </ListItem>
  );
};

DocumentListItem.propTypes = {
  document: PropTypes.shape({
    title: PropTypes.string,
    attachments: PropTypes.arrayOf(
      PropTypes.shape({
        filename: PropTypes.string,
        mimeType: PropTypes.string,
      }),
    ),
  }),
};

export default DocumentListItem;
